import { headers } from './constants';
import axios from 'axios';
import {
    LANDING_PAGE_SCENARIO_STATS_URL,
    TOP_AND_EMERGING_SPIKES_URL,
    TOP_RANKS_URL
} from 'constants/api';
import queryString from 'query-string';

export const landingAPI = {
    fetchTopRanks: (params) =>
        axios
            .get(`${TOP_RANKS_URL}?${queryString.stringify(params)}`, {
                headers
            })
            .then((response) => response.data),
    fetchTopAndEmergingSpikes: (params) =>
        axios
            .get(
                `${TOP_AND_EMERGING_SPIKES_URL}?${queryString.stringify(
                    params
                )}`,
                { headers }
            )
            .then((response) => response.data),
    fetchLandingPageStats: (params) =>
        axios
            .get(
                `${LANDING_PAGE_SCENARIO_STATS_URL}?${queryString.stringify(
                    params
                )}`,
                { headers }
            )
            .then((response) => response.data)
};
